/* Mythic theme.js — small, dependency-free. */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- external links open in a new tab, so the store stays open behind them ----------
     Covers every link that leaves the store: menus, page content, socials, anything added in the admin later.
     Checked at click time, so links injected after load are covered too. Shopify's own checkout and
     customer-account pages are part of the store's flow and stay in the same tab. */
  const staysInTab = /(^|\.)(shopify\.com|myshopify\.com|shop\.app)$/;
  document.addEventListener('click', e => {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a || !/^https?:$/.test(a.protocol) || a.hostname === location.hostname || staysInTab.test(a.hostname)) return;
    a.target = '_blank';
    if (!/\bnoopener\b/.test(a.rel)) a.rel = (a.rel ? a.rel + ' ' : '') + 'noopener';
  }, true);

  /* ---------- header shadow ---------- */
  const header = $('.js-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- drawer ---------- */
  $$('[data-drawer-open]').forEach(btn => {
    btn.addEventListener('click', () => {
      const d = document.getElementById(btn.getAttribute('data-drawer-open'));
      if (!d) return;
      d.setAttribute('open', '');
      btn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      const first = d.querySelector('button, a');
      first && first.focus();
    });
  });
  $$('[data-drawer]').forEach(d => {
    const close = () => {
      d.removeAttribute('open');
      document.body.style.overflow = '';
      $$('[data-drawer-open]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    };
    $$('[data-drawer-close]', d).forEach(el => el.addEventListener('click', close));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && d.hasAttribute('open')) close(); });
  });

  /* ---------- close <details> menus on outside click ---------- */
  document.addEventListener('click', e => {
    $$('details.js-details[open]').forEach(d => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* ---------- header dropdowns: open on hover for mouse users, with a grace period on exit ---------- */
  if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    $$('.header__nav details.js-details').forEach(d => {
      const li = d.closest('li');
      let t;
      li.addEventListener('mouseenter', () => { clearTimeout(t); d.setAttribute('open', ''); });
      li.addEventListener('mouseleave', () => { clearTimeout(t); t = setTimeout(() => d.removeAttribute('open'), 250); });
      // hover already opened it, so a mouse click shouldn't toggle it shut; keyboard Enter/Space (detail 0) still toggles
      $('summary', d).addEventListener('click', e => { if (e.detail > 0) e.preventDefault(); });
    });
  }

  /* ---------- crystal parallax ---------- */
  const px = $$('[data-parallax]');
  if (px.length && !reduceMotion) {
    let raf = 0;
    const update = () => {
      const y = window.scrollY;
      px.forEach(el => {
        const f = parseFloat(el.getAttribute('data-parallax')) || 0;
        el.style.transform = `translate3d(0, ${y * f}px, 0)`;
      });
      raf = 0;
    };
    window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
  }

  /* ---------- quantity steppers ---------- */
  $$('[data-qty]').forEach(q => {
    const input = $('input', q);
    const clamp = v => Math.max(parseInt(input.min || '0', 10), v);
    $('[data-qty-minus]', q).addEventListener('click', () => { input.value = clamp((parseInt(input.value, 10) || 0) - 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
    $('[data-qty-plus]', q).addEventListener('click', () => { input.value = clamp((parseInt(input.value, 10) || 0) + 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
  });

  /* ---------- money ---------- */
  const money = cents => {
    const fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    const n = (cents / 100);
    const amount = fmt.includes('no_decimals') ? Math.round(n).toString() : n.toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, fmt.includes('comma_separator') ? amount.replace('.', ',') : amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  };

  /* ---------- product: variant picker ---------- */
  const productEl = $('[data-product]');
  if (productEl) {
    const json = $('[data-product-json]', productEl);
    const product = json ? JSON.parse(json.textContent) : null;
    const form = $('[data-product-form]', productEl);
    const idInput = $('[data-variant-id]', productEl);
    const priceEl = $('[data-price]', productEl);
    const addBtn = $('[data-add-to-cart]', productEl);
    const addLabel = $('[data-add-label]', productEl);
    const err = $('[data-form-error]', productEl);
    const mainMedia = $('[data-main-media]', productEl);

    const showMedia = id => {
      if (!mainMedia) return;
      $$('img[data-media-id]', mainMedia).forEach(img => { img.hidden = String(img.dataset.mediaId) !== String(id); });
      $$('[data-thumb]').forEach(b => b.toggleAttribute('aria-current', String(b.dataset.thumb) === String(id)));
    };
    $$('[data-thumb]').forEach(b => b.addEventListener('click', () => showMedia(b.dataset.thumb)));

    const selectedOptions = () => $$('input[type=radio]:checked', form).map(i => i.value);

    const applyVariant = v => {
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = theme.strings.unavailable; return;
      }
      idInput.value = v.id;
      priceEl.innerHTML = v.compare_at_price && v.compare_at_price > v.price
        ? `<span class="price price--sale">${money(v.price)}</span> <s>${money(v.compare_at_price)}</s>`
        : `<span class="price">${money(v.price)}</span>`;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? theme.strings.addToCart : theme.strings.soldOut;
      if (v.featured_media) showMedia(v.featured_media.id);
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      // grey out unavailable values for the next option
      const sel = selectedOptions();
      $$('input[type=radio]', form).forEach(input => {
        const idx = parseInt(input.dataset.optionIndex, 10);
        const test = sel.slice(); test[idx] = input.value;
        const match = product.variants.find(x => x.options.every((o, i) => o === test[i]));
        input.nextElementSibling.classList.toggle('is-unavailable', !match || !match.available);
      });
    };

    if (product && form) {
      form.addEventListener('change', e => {
        if (e.target.type !== 'radio') return;
        const sel = selectedOptions();
        applyVariant(product.variants.find(v => v.options.every((o, i) => o === sel[i])));
      });
      const initial = product.variants.find(v => String(v.id) === String(idInput.value));
      if (initial) applyVariant(initial);

      form.addEventListener('submit', async e => {
        e.preventDefault();
        err.hidden = true;
        addBtn.disabled = true;
        addBtn.dataset.state = 'loading';
        try {
          const res = await fetch(theme.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: idInput.value, quantity: parseInt($('input[name=quantity]', form).value, 10) || 1 }) });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Error');
          const cart = await (await fetch(theme.routes.cart + '.js')).json();
          $$('[data-cart-count]').forEach(el => {
            el.textContent = cart.item_count; el.dataset.count = cart.item_count;
            el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop');
          });
          addBtn.dataset.state = 'success';
          setTimeout(() => { delete addBtn.dataset.state; addBtn.disabled = false; }, 1600);
        } catch (ex) {
          err.textContent = ex.message; err.hidden = false;
          delete addBtn.dataset.state; addBtn.disabled = false;
        }
      });
    }
  }

  /* ---------- cart: live quantity change ---------- */
  const cartForm = $('[data-cart-form]');
  if (cartForm) {
    let t;
    cartForm.addEventListener('change', e => {
      const input = e.target.closest('[data-line-qty]');
      if (!input) return;
      clearTimeout(t);
      t = setTimeout(async () => {
        try {
          const res = await fetch(theme.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: input.dataset.lineQty, quantity: parseInt(input.value, 10) || 0 }) });
          if (!res.ok) throw new Error();
          location.reload();
        } catch (_) { cartForm.submit(); }
      }, 350);
    });
  }

  /* ---------- collection: facets & sort auto-submit ---------- */
  const facets = $('[data-facets-form]');
  if (facets) {
    facets.addEventListener('change', e => {
      if (e.target.matches('input[type=checkbox], [data-sort-select]')) {
        const url = new URL(location.href);
        const params = new URLSearchParams(new FormData(facets));
        // keep page reset
        params.delete('page');
        location.href = url.pathname + '?' + params.toString();
      }
    });
  }

  /* ---------- addresses: delete + country default ---------- */
  $$('[data-delete-address]').forEach(b => b.addEventListener('click', () => {
    if (!confirm(b.dataset.confirmMessage)) return;
    const f = document.createElement('form'); f.method = 'post'; f.action = b.dataset.deleteAddress;
    f.innerHTML = '<input type="hidden" name="_method" value="delete">';
    document.body.appendChild(f); f.submit();
  }));
  $$('select[data-default]').forEach(s => { if (s.dataset.default) s.value = s.dataset.default; });

  /* ---------- event trailer: the poster button starts the video ---------- */
  $$('[data-trailer]').forEach(f => {
    const btn = $('[data-trailer-play]', f), video = $('video', f);
    if (!btn || !video) return;
    btn.addEventListener('click', () => { btn.hidden = true; video.play().catch(() => {}); video.focus(); });
  });

  /* ---------- event ticker: an odometer that rolls to each new registration count ----------
     <span data-odometer data-value="2671" data-feed="https://…" data-field="registrations" data-interval="30">
     data-feed is any CORS-enabled JSON URL; data-field is a dotted path into it. Without a feed the number
     just rolls in once. ?ticker=demo on the page simulates registrations so the motion can be reviewed. */
  const odometers = $$('[data-odometer]');
  if (odometers.length) {
    const fmt = n => Math.max(0, Math.round(n)).toLocaleString('en-US');
    const build = (el, n) => {
      el.textContent = '';
      el.setAttribute('aria-label', fmt(n));
      for (const ch of fmt(n)) {
        if (!/\d/.test(ch)) { const s = document.createElement('span'); s.className = 'odo__sep'; s.textContent = ch; el.append(s); continue; }
        const d = document.createElement('span'); d.className = 'odo__d'; d.setAttribute('aria-hidden', 'true');
        const reel = document.createElement('span'); reel.className = 'odo__reel';
        reel.innerHTML = '0123456789'.split('').map(x => `<span>${x}</span>`).join('');
        d.append(reel); el.append(d);
      }
      el.dataset.shown = fmt(n); // reels start at 0; set() rolls them
    };
    const set = (el, n) => {
      // a new digit (999 → 1,000) rebuilds the reels at 0, then they roll into place
      if (fmt(n).length !== (el.dataset.shown || '').length) { build(el, n); void el.offsetWidth; }
      el.setAttribute('aria-label', fmt(n));
      const digits = fmt(n).replace(/\D/g, '');
      $$('.odo__reel', el).forEach((r, i) => { r.style.transform = `translateY(${-Number(digits[i]) * 10}%)`; });
      el.dataset.shown = fmt(n);
    };
    const bump = (el, diff) => {
      const b = document.createElement('span'); b.className = 'odo__bump'; b.textContent = '+' + fmt(diff);
      el.append(b); setTimeout(() => b.remove(), 1600);
    };
    const pick = (obj, path) => path.split('.').reduce((o, k) => (o == null ? o : o[k]), obj);
    const demo = new URLSearchParams(location.search).get('ticker') === 'demo';

    odometers.forEach(el => {
      let value = parseInt(el.dataset.value, 10) || 0;
      const label = el.closest('div') && $('dt', el.closest('div'));
      const goLive = () => {
        if (el.dataset.live) return;
        el.dataset.live = '1';
        if (label && el.dataset.liveLabel) label.textContent = el.dataset.liveLabel;
        if (label) label.insertAdjacentHTML('afterbegin', '<span class="odo__live" aria-hidden="true"></span>');
      };
      const update = n => {
        if (!(n > value)) return;
        const diff = n - value; value = n;
        set(el, value); bump(el, diff); goLive();
      };
      // roll in from zero once the hero has revealed
      build(el, value);
      setTimeout(() => set(el, value), reduceMotion ? 0 : 1100);

      const feed = el.dataset.feed;
      if (feed) {
        const every = Math.max(10, parseInt(el.dataset.interval, 10) || 30) * 1000;
        const poll = () => {
          if (document.hidden) return;
          fetch(feed, { cache: 'no-store' }).then(r => r.ok ? r.json() : null)
            .then(j => { const n = j && parseInt(pick(j, el.dataset.field || 'registrations'), 10); if (n) { goLive(); update(n); } })
            .catch(() => {});
        };
        poll(); setInterval(poll, every);
        document.addEventListener('visibilitychange', () => { if (!document.hidden) poll(); });
      } else if (demo) {
        goLive();
        const tick = () => { update(value + 1 + (Math.random() < .2 ? 1 : 0)); setTimeout(tick, 2500 + Math.random() * 4000); };
        setTimeout(tick, 2600);
      }
    });
  }

  /* ---------- motion: count-up (data-count-delay waits for a delayed reveal) ---------- */
  const countUp = el => {
    const raw = el.textContent.trim();
    if (reduceMotion) return;
    const delay = parseInt(el.dataset.countDelay, 10);
    if (delay > 0) { delete el.dataset.countDelay; el.textContent = raw.replace(/\d/g, '0'); setTimeout(() => { el.textContent = raw; countUp(el); }, delay); return; }
    const m = raw.match(/^([^\d]*)([\d.,]+)(.*)$/);
    if (!m) return;
    const [, pre, num, post] = m;
    const target = parseFloat(num.replace(/,/g, ''));
    if (isNaN(target)) return;
    const dec = (num.split('.')[1] || '').length;
    const comma = num.includes(',');
    const fmt = v => { let out = v.toFixed(dec); if (comma) out = out.replace(/\B(?=(\d{3})+(?!\d))/g, ','); return pre + out + post; };
    const t0 = performance.now(), dur = 1100;
    const tick = now => {
      const p = Math.min(1, (now - t0) / dur);
      const e = 1 - Math.pow(1 - p, 3);
      el.textContent = p < 1 ? fmt(target * e) : raw;
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  /* ---------- motion: stagger grids + stats when they scroll into view ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(en => {
      if (!en.isIntersecting) return;
      const el = en.target;
      el.classList.add('is-in');
      if (el.hasAttribute('data-count')) countUp(el);
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  $$('[data-stagger]').forEach(g => {
    Array.from(g.children).forEach((c, i) => c.style.setProperty('--i', Math.min(i, 11)));
    io ? io.observe(g) : g.classList.add('is-in');
  });
  $$('[data-count]').forEach(el => { io ? io.observe(el) : el.classList.add('is-in'); });
  $$('[data-draw]').forEach(el => { io ? io.observe(el) : el.classList.add('is-in'); });

  /* ---------- motion: event emblem intro starts once its images are decoded ----------
     On a cold load the emblem and glass images arrive mid-intro, which shows as a stutter. The CSS intro
     is gated on .is-ready; decode both first (with a cap so a slow image never blocks the page). */
  $$('[data-emblem]').forEach(emblem => {
    const ready = () => requestAnimationFrame(() => emblem.classList.add('is-ready'));
    const img = $('.event-emblem__img', emblem), light = $('.event-light', emblem);
    const loaded = el => new Promise(res => {
      if (el.complete && el.naturalWidth) return res();
      el.addEventListener('load', res, { once: true });
      el.addEventListener('error', res, { once: true });
    });
    // loaded, then decoded so the first painted frame is ready; decode is capped in case it never settles
    const decoded = el => loaded(el).then(() => el.decode && Promise.race([el.decode().catch(() => {}), new Promise(res => setTimeout(res, 300))]));
    const waits = [];
    if (img) waits.push(decoded(img));
    if (light && light.dataset.glass) { const g = new Image(); g.src = light.dataset.glass; waits.push(decoded(g)); }
    Promise.all(waits).then(ready);
    setTimeout(ready, 2500);
  });

  /* ---------- motion: event emblem, the loop light speeds up while the pointer is on it ---------- */
  if (!reduceMotion) $$('[data-emblem]').forEach(emblem => {
    if (!emblem.getAnimations) return;
    let target = 1, rate = 1, raf = 0;
    const step = () => {
      rate += (target - rate) * 0.08;
      if (Math.abs(target - rate) < 0.01) rate = target;
      $$('.event-light i, .event-light b', emblem).forEach(el => el.getAnimations().forEach(a => { a.playbackRate = rate; }));
      raf = rate === target ? 0 : requestAnimationFrame(step);
    };
    const ease = v => { target = v; if (!raf) raf = requestAnimationFrame(step); };
    emblem.addEventListener('pointerenter', () => ease(2.8));
    emblem.addEventListener('pointerleave', () => ease(1));
  });

  /* ---------- motion: deal cards face-up once a card is well into view ---------- */
  const dealIo = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); dealIo.unobserve(en.target); } });
  }, { threshold: 0.35 }) : null;
  $$('[data-deal]').forEach(el => { dealIo ? dealIo.observe(el) : el.classList.add('is-in'); });

  /* ---------- motion: tilt cards (pointer devices only) ---------- */
  if (!reduceMotion && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    $$('[data-tilt]').forEach(el => {
      const max = parseFloat(el.dataset.tilt) || 4;
      el.addEventListener('pointermove', e => {
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--ry', (x * max * 2).toFixed(2) + 'deg');
        el.style.setProperty('--rx', (-y * max * 2).toFixed(2) + 'deg');
        // pointer position for foil highlights (talent cards)
        el.style.setProperty('--mx', ((x + 0.5) * 100).toFixed(1) + '%');
        el.style.setProperty('--my', ((y + 0.5) * 100).toFixed(1) + '%');
      });
      el.addEventListener('pointerleave', () => { el.style.setProperty('--rx', '0deg'); el.style.setProperty('--ry', '0deg'); });
    });
  }

  /* ---------- motion: header nav sliding indicator ---------- */
  const nav = $('.header__nav');
  const ind = nav && $('.header__nav-ind', nav);
  if (nav && ind) {
    const links = $$(':scope > li > a, :scope > li > details > summary', nav);
    const move = el => {
      const nr = nav.getBoundingClientRect(), r = el.getBoundingClientRect();
      ind.style.width = r.width + 'px';
      ind.style.transform = 'translateX(' + (r.left - nr.left) + 'px)';
      ind.classList.add('is-on');
    };
    const current = links.find(a => a.hasAttribute('aria-current'));
    const rest = () => { current ? move(current) : ind.classList.remove('is-on'); };
    links.forEach(a => { a.addEventListener('mouseenter', () => move(a)); a.addEventListener('focus', () => move(a)); });
    nav.addEventListener('mouseleave', rest);
    nav.addEventListener('focusout', rest);
    rest();
    window.addEventListener('resize', rest);
  }
})();
